export default [
  {
    header: 'sections.navigation',
    sections: [
      // {
      //   label: 'sections.home',
      //   route: '/home'
      // },
      {
        label: 'sections.campaignDesigner',
        route: '/campaigns',
        requiredScope: 'VIEW_CAMPAIGN'
      },
      {
        label: 'sections.offerViewer',
        route: '/offers-viewer',
        requiredScope: 'OFFERS_VIEWER'
      },
      // {
      //   label: 'sections.campaignMonitoring',
      //   route: '/monitoring'
      // },
      {
        label: 'sections.executionRules.label',
        sections: [
          {
            label: 'sections.executionRules.exclusionRules.label',
            route: '/executionrules/exclusionrules'
          },
          {
            label: 'sections.executionRules.sendingRules.label',
            route: '/executionrules/sendingrules'
          }
        ],
        requiredScope: ['VIEW_EXECUTION_RULE']
      },
      {
        label: 'sections.fastCounter',
        route: '/preview',
        requiredScope: ['VIEW_FAST_COUNTER']
      }
    ]
  },
  // {
  //   header: 'sections.customization',
  //   sections: [
  //     {
  //       label: 'sections.domainTablesConfiguration',
  //       route: '/domainTablesConfiguration'
  //     }
  //   ],
  //   requiredScope: 'MANAGE_DOMAIN_SETTINGS'
  // },
  {
    header: 'sections.administration',
    sections: [
      {
        label: 'sections.userManagement',
        route: '/users'
      },
      {
        label: 'sections.cleanIt',
        route: '/clean-it',
        requiredScope: 'CLEAN_IT'
      }
    ],
    requiredScope: 'MANAGE_SETTINGS'
  }
]
